import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shouqianjian",
  "use": "icon-shouqianjian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shouqianjian\"><defs><style type=\"text/css\"></style></defs><path d=\"M818.535 320.157H152.933v-89.602h665.602v89.602z m0 469.503H152.933v-90.113h665.602v90.113zM630.628 556.7H152.933v-91.649h479.742l-2.047 91.649z m239.106-164.864v238.078L675.687 510.617l194.047-118.781z m0 0\" p-id=\"4240\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol